<template>
    <div class="layout-sidebar">
        <a class="logo-img" href="/">
            <img src="static/logo.png" />
        </a>
        <a class="logo-text" href="/">
            <!-- <u class="c-error">BCI</u> -->
            汉字义符测评管理系统</a
        >
        <hr style="border-color: #4b545c; margin: 0;" />
        <div id="sidebar" class="d-flex-item p-sm scrollbar">
            <div
                class="sidebar-menu"
                :class="{ group: item.children }"
                v-for="(item, index) in menuData"
                :key="index"
                v-if="menuData.length > 0"
            >
                <a
                    slot="title"
                    class="d-flex justify-start"
                    :class="{ active: menuActive === index }"
                    v-if="!item.children"
                    @click="onMenu(item, index)"
                >
                    <img :src="item.icon" />
                    <span class="d-flex-item plr-sm">{{ item.name }}</span>
                </a>
                <a
                    slot="group-title"
                    class="d-flex justify-start"
                    v-if="item.children"
                >
                    <img :src="item.icon" />
                    <span class="d-flex-item plr-sm">{{ item.name }}</span>
                    <i class="arrow" />
                </a>
                <ul class="group" v-if="item.children">
                    <li v-for="(child, index) in item.children" :key="index">
                        <a
                            class="d-flex justify-start"
                            @click="onMenu(child, index)"
                            >{{ child.name }}</a
                        >
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import axios from "axios";

export default {
    data() {
        return {
            menuActive: 0,
            menuData: []
        };
    },
    created() {},
    async mounted() {
        await this.getSidebar();
    },
    methods: {
        async getSidebar() {
            let res = await axios.get("static/json/sidebar.json");
            console.log("this.getSidebar---------->", res);
            this.menuData = [] = res.data.data;
            let array = res.data.data;
            for (let i = 0; i < array.length; i++) {
                let item = array[i];
                if (item.router === "index") {
                    item.show = true;
                }
                if (array[i].auth) {
                    item.keys = [];
                    item.auth.forEach(it => item.keys.push(it.key));
                    item.show = this.$common.permissions(item.keys);
                    delete item.keys;
                }
                if (item.children) {
                    item.show = false;
                    for (let i = 0; i < item.children.length; i++) {
                        let child = item.children[i];
                        child.keys = [];
                        if (child.auth) {
                            child.auth.forEach(it => child.keys.push(it.key));
                            child.show = this.$common.permissions(child.keys);
                            delete child.keys;
                        }
                        if (child.show) {
                            item.show = true;
                        }
                    }
                }
            }
            this.menuData = [] = array;
            localStorage.setItem("router", this.menuData[0].router);
        },
        onMenu(data, i) {
            console.log("this.onMenu---------->", data, i);
            // this.menuActive = i;
            // this.menuToggle = true;
            localStorage.setItem("router", data.router);
            this.$router.push({
                name: data.router,
                params: data
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue